import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { LocaleService } from '@sm360/widget-commons-core-services';

import Term from 'payment-calculator/components/PaymentCalculatorDetails/components/CalculatorTerms/Term.jsx';
import * as Actions from 'payment-calculator/actions/paymentCalculatorActions.js';
import { PurchaseMethods, CurrencyFormats } from '@sm360/widget-commons-vehicle';

import 'payment-calculator/components/PaymentCalculatorDetails/components/CalculatorTerms/CalculatorTerms.scss';

class CalculatorTerms extends React.Component {
    render() {
        const selectedTerm = this.props.purchaseMethods.getSelectedFinanceTerm();
        const terms = this.props.purchaseMethods.lease.selected
            ? this.props.purchaseMethods.lease.terms
            : this.props.purchaseMethods.finance.terms;
        const paymentFrequencyLabels = this.props.purchaseMethods.getPaymentFrequencyLabels(false, LocaleService);
        const termsBlock = terms.map((term) => {
            return (
                <Term
                    key={term.term}
                    paymentFrequencyLabels={paymentFrequencyLabels}
                    payment={LocaleService.l(term.calculatedPayment, CurrencyFormats.CURRENCY_0)}
                    term={term.term}
                    apr={term.apr}
                    handleClick={this.props.actions.selectTerm}
                    selectedTerm={selectedTerm}
                    purchaseMethods={this.props.purchaseMethods}
                />
            );
        });

        return <div className="calculator-terms clearfix">{termsBlock}</div>;
    }
}

CalculatorTerms.propTypes = {
    purchaseMethods: PropTypes.instanceOf(PurchaseMethods.PurchaseMethodsModel),
    actions: PropTypes.shape({
        selectTerm: PropTypes.func.isRequired,
    }),
};

CalculatorTerms.displayName = 'CalculatorTerms';

function mapStateToProps(state) {
    return {
        purchaseMethods: state.purchaseMethods,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Actions, dispatch),
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CalculatorTerms);
export { CalculatorTerms };



// WEBPACK FOOTER //
// ./src/components/PaymentCalculatorDetails/components/CalculatorTerms/CalculatorTerms.jsx